import React, {useState} from "react";
import {CustomerCreditLogTable} from "../../credits/CustomerCreditLogTable";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {useObserver} from "mobx-react-lite";
import moment from "moment";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
const CustomerAccountingPage = () => {
    const [creditStats, setCreditStats] = useState(null);
    const defaultDateRange = [moment().subtract(30, "days"), moment()];
    const [selectedDateRange, setSelectedDateRange] = useState(defaultDateRange);

    return useObserver(() => (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            {/* <CustomerAccountingRow
                setCreditStats={setCreditStats}
                selectedDateRange={selectedDateRange}
            /> */}
            <CustomerCreditLogTable
                creditStats={creditStats}
                setCreditStats={setCreditStats}
                selectedDateRange={selectedDateRange}
                setSelectedDateRange={setSelectedDateRange}
                defaultDateRange={defaultDateRange}
            />
        </CustomerFluidSubPageLayout>
    ));
};

export default CustomerAccountingPage;
